import type { ExpansionWatchStatus } from "@repo/game-admin"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import {
	LIST_PRESETS,
	TODO_FILTERS,
	type TodoFilter,
} from "@/features/upcoming-expansions/list-presets"
import { UpcomingExpansionsPage } from "@/features/upcoming-expansions/UpcomingExpansionsPage"
import { WATCH_STATUSES } from "@/features/upcoming-expansions/watch-status"

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
const NO_TODO: TodoFilter[] = []
const NO_STATUSES: ExpansionWatchStatus[] = []

const searchSchema = z.object({
	view: z.enum(["list", "calendar", "sources"]).optional().catch(undefined),
	preset: z.enum(LIST_PRESETS).optional().catch(undefined),
	statuses: z.array(z.enum(WATCH_STATUSES)).optional().catch(undefined),
	muted: z.boolean().optional().catch(undefined),
	games: z.array(z.string()).optional().catch(undefined),
	from: isoDate.optional().catch(undefined),
	to: isoDate.optional().catch(undefined),
	todo: z.array(z.enum(TODO_FILTERS)).optional().catch(undefined),
	changed: z.boolean().optional().catch(undefined),
	month: z
		.string()
		.regex(/^\d{4}-\d{2}$/)
		.optional()
		.catch(undefined),
	entry: z.string().optional(),
})

export const Route = createFileRoute("/catalogue/upcoming/")({
	component: UpcomingExpansionsRoute,
	validateSearch: searchSchema,
})

function UpcomingExpansionsRoute() {
	const search = Route.useSearch()
	const navigate = Route.useNavigate()

	return (
		<UpcomingExpansionsPage
			view={search.view ?? "list"}
			filters={{
				preset: search.preset ?? "all",
				statuses: search.statuses ?? NO_STATUSES,
				muted: search.muted ?? false,
				from: search.from,
				to: search.to,
				todo: search.todo ?? NO_TODO,
				changed: search.changed ?? false,
			}}
			games={search.games ?? []}
			month={search.month}
			entry={search.entry}
			onSearchChange={(next) =>
				navigate({
					search: (previous) => ({ ...previous, ...next }),
					replace: true,
				})
			}
		/>
	)
}
